/*
 * Copyright (c) 2021 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import React, {FC, ReactElement} from "react";
import { Loader } from "@scuf/common";
import {Redirect, Route, RouteProps, useHistory} from "react-router-dom";
import { LoggedOutComponent, LoginComponent, useSSOClient, CallbackComponent } from "@forge/sso-client";
import {
    IDIYGatewayManagementProps,
    IFCPDIYGatewayManagementProps
} from "../../stores/GatewayManager/IGatewayRegistrationInterfaces";
import {UserManager} from "@forge/sso-client";

/**
 * The logout route
 *
 * @param children
 * @param rest
 * @constructor
 */
export const FCLogoutRoute: FC<RouteProps> = ({ children, ...rest }) => <Route
    {...rest}
    children={() => (
        <LoggedOutComponent autoRenew={true} loadingComponent={Loader} />
    )}
/>

/**
 * The login route
 *
 * @param children
 * @param rest
 * @constructor
 */
export const FCLoginRoute: FC<RouteProps> = ({ children, ...rest }) => <Route
    {...rest}
    children={() => (
        <LoginComponent loadingComponent={Loader} />
    )}
/>

/**
 * The callback route
 *
 * @param children
 * @param rest
 * @constructor
 */
export const FCCallbackRoute: FC<RouteProps> = ({ children, ...rest }) => {
    const navigate = useHistory();
    const navToProjects = () => {
        navigate.push('/fcp/register/main');
    };
    return <Route
        {...rest}
        children={() => (
            <CallbackComponent onCallback={navToProjects} loadingComponent={Loader} />
        )}
    />
};

/**
 * Private route
 *
 * @param children
 * @param rest
 * @constructor
 */
export const FCPrivateDIYAppRoute: FC<RouteProps> = ({ children, ...rest }) => {
    const { user } = useSSOClient();
    return <Route {...rest} children={() => {
        if (user) {
            let diyApp = children as ((props: IFCPDIYGatewayManagementProps) => ReactElement);
            let p : IDIYGatewayManagementProps = {
                userInfo: {
                    firstName: user.profile.given_name || '',
                    lastName: user.profile.family_name || '',
                    userPrincipalName: user.profile.email || ''
                },
                logout: () => {
                    UserManager.getInstance().signoutRedirect();
                }
            };
            return diyApp(p)
        } else {
            return <Redirect
                to={{
                    pathname: "/fcp/register/login",
                }}
            />;
        }
    }} />
};